import React from 'react';
import { SCREEN_SIZE } from 'types';
import { Button, Modal } from 'carbon-components-react';
import LookUpAndLiveButton from '../../LookUpAndLiveButton';
import LookUpAndLiveContent, {
  OpenLookUpAndLiveButton
} from '../../LookUpAndLiveContent';
import PreviewerSuperModal from '../../PreviewerSuperModal';
import Downloads from '../../Downloads';
import Tools from '../../Tools';
import { Close20 } from '@carbon/icons-react';
import './index.scss';

type Props = {
  screenSize: String;
  enquiryId: number;
  responsesExpired: boolean;
  showResponsesExpiredModal: boolean;
  isModal: boolean;
  handleCLOOpenModal: any;
  isLoading: boolean;
  enquiryDetail: any;
  shareId: string;
  setIsDownloadPdf: Function;
  setIsDownloadZip: Function;
  lualExtent: any;
  isFromSwxLocate: boolean;
  lualZoomLevel?: number | null;
  lualMapZoomLevel?: number | null;
  onLualMapZoomChange?: (zoomLevel: number) => void;

  // Mobile-specific props
  selectedReferralObj: any;
  showDMFViewer: boolean;
  setShowDMFViewer: Function;
  previewData: any;
  getPlanResponsesAboutRef: any;
  inboundEmailIdToDownload: number;
  showPreviewerSuperModal: boolean;
  onClosePreviewerSuperModal: Function;
  handleOpenLual: () => void;
  handleExpandLual: () => void;
  showLualSuperModal: boolean;
  onCloseLualSuperModal: () => void;
  allResponsesReceived: boolean;
  copyPageLinkState: any;
  handleRenewEnquiry: Function;
  handleCopyPageLink: Function;
  isOwner: boolean;
};

const MobileViewDownloadAndTools: React.FC<Props> = ({
  screenSize,
  enquiryId,
  responsesExpired,
  isModal,
  handleCLOOpenModal,
  isLoading,
  enquiryDetail,
  shareId,
  setIsDownloadPdf,
  setIsDownloadZip,
  lualExtent,
  isFromSwxLocate,
  lualZoomLevel,
  lualMapZoomLevel,

  selectedReferralObj,
  showDMFViewer,
  setShowDMFViewer,
  previewData,
  showPreviewerSuperModal,
  onClosePreviewerSuperModal,
  getPlanResponsesAboutRef,
  inboundEmailIdToDownload,
  handleOpenLual,
  handleExpandLual,
  showLualSuperModal,
  onCloseLualSuperModal,
  allResponsesReceived,
  copyPageLinkState,
  handleRenewEnquiry,
  handleCopyPageLink,
  isOwner
}) => {
  return (
    <div
      id="getPlans"
      className={`mobile-view-download-tools ${
        isFromSwxLocate ? 'locate-theme' : ''
      }`}
    >
      <div className="get-plans-actions mobile-view-get-plans-actions">
        {lualExtent && (
          <LookUpAndLiveButton
            responsesExpired={responsesExpired}
            isLoading={isLoading}
            onShowLual={handleExpandLual}
          />
        )}
        <Downloads
          key={`mobile-downloads-${lualMapZoomLevel || 'loading'}`}
          allResponsesReceived={allResponsesReceived}
          enquiryId={enquiryId}
          shareId={shareId}
          isSmallScreen={screenSize === SCREEN_SIZE.SM}
          responsesExpired={responsesExpired}
          isLoading={isLoading}
          confirmationFileId={enquiryDetail?.confirmationFileId}
          setIsDownloadPdf={setIsDownloadPdf}
          setIsDownloadZip={setIsDownloadZip}
          lualZoomLevel={lualZoomLevel}
          lualMapZoomLevel={lualMapZoomLevel}
        />
        {!isFromSwxLocate && (
          <Tools
            copyPageLinkState={copyPageLinkState}
            renewEnquiryHandler={handleRenewEnquiry}
            copyPageLinkHandler={handleCopyPageLink}
            showCopyPageLink={isOwner && !responsesExpired}
            isSmallScreen={screenSize === SCREEN_SIZE.SM}
            handleCLOOpenModal={handleCLOOpenModal}
            responsesExpired={responsesExpired}
            showResponsesExpiredModal={false}
            isLoading={isLoading}
          />
        )}
        <div
          className="get-plans-responses-about"
          ref={getPlanResponsesAboutRef}
        >
          <div className="get-plans-responses-about-description mobile-view-download-tools-responses-about-description">
            <span className="get-plans-responses-about-description-title">
              What you should know about responses and plans.
            </span>
            Plans are indicative only and property connections may not be shown.
            All assets may not be included in the response provided. You can
            engage a skilled locator to assist with the location of assets.
            Check your spam/junk folders for missing responses. Please follow
            safe excavation advice.
          </div>
        </div>
      </div>
      {showPreviewerSuperModal && (
        <PreviewerSuperModal
          showDMFViewer={showDMFViewer}
          setShowDMFViewer={setShowDMFViewer}
          isOpen={showPreviewerSuperModal}
          onClose={onClosePreviewerSuperModal}
          previewData={previewData}
          selectedReferralObj={selectedReferralObj}
          isModal={isModal}
          inboundEmailId={inboundEmailIdToDownload}
          enquiryId={enquiryId}
        />
      )}
      {showLualSuperModal && (
        <div className="previewer-super-modal">
          <Modal
            open={showLualSuperModal}
            modalHeading={
              <OpenLookUpAndLiveButton
                isLoading={false}
                onOpenLual={handleOpenLual}
                data-testid="open-in-lual-button"
              />
            }
            onRequestClose={onCloseLualSuperModal}
            passiveModal
            size="lg"
            className={`lual-super-modal super-modal mobile-view-lual-super-modal ${
              isModal ? '' : 'single-modal'
            }`}
          >
            <div className="super-modal-content">
              <div className="mobile-view-download-tools-lual-header">
                <div className="mobile-view-download-tools-lual-header-container">
                  <div className="mobile-view-download-tools-lual-header-content">
                    <img
                      src="../lual-logo.png"
                      alt="LUAL"
                      className="mobile-view-download-tools-lual-logo"
                    />
                    <div className="mobile-view-download-tools-lual-buttons">
                      <OpenLookUpAndLiveButton
                        isLoading={false}
                        onOpenLual={handleOpenLual}
                        data-testid="open-in-lual-button"
                      />
                      <Button
                        kind="ghost"
                        size="field"
                        onClick={() => {
                          onCloseLualSuperModal();
                        }}
                        className="mobile-view-download-tools-lual-close-button"
                      >
                        <Close20 fill="#0F62FE" />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="super-modal-content-body">
                <LookUpAndLiveContent
                  extent={lualExtent}
                  enquiryShape={enquiryDetail?.shape}
                  onOpenLual={handleOpenLual}
                  onExpandLual={onCloseLualSuperModal}
                />
              </div>
            </div>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default MobileViewDownloadAndTools;
